import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row, Select, Spin, Switch } from "antd";
import { domainRestrictionModel, selection_dropdown } from "../../constants";

const { Option } = Select;

const DomainRestriction = ({ widget, handleWidgetChange }) => {
  const [domainRestriction, setDomainRestriction] = useState({
    ...domainRestrictionModel,
  });

  const handleSave = () => {
    handleWidgetChange({ domainRestriction, id: widget.id });
  };

  useEffect(() => {
    if (widget.domainRestriction)
      setDomainRestriction({ ...widget.domainRestriction });
    else setDomainRestriction({ ...domainRestrictionModel });
  }, [widget.id, widget.domainRestriction]);
  return (
    <div>
      <Spin spinning={false}>
        <Card className="setting_wrapper">
          <Row className="center_items setting_label">
            <Col span={12}>
              <h4 className="p-color">Domain Restriction</h4>
            </Col>
            <Col span={12} className="action">
              <div style={{ textAlign: "end" }}>
                <Switch
                  name="status"
                  id="custom-switch"
                  checked={domainRestriction.enabled}
                  onChange={(checked) => {
                    if (!checked)
                      setDomainRestriction({ ...domainRestrictionModel });
                    else
                      setDomainRestriction({
                        ...domainRestriction,
                        enabled: checked,
                      });
                  }}
                />
              </div>

              <div onClick={handleSave} className="action_btn ml-2">
                <i className="fa-regular fa-floppy-disk"></i>
                <span>Save</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Select
                disabled={!domainRestriction.enabled}
                className="select_feld"
                placeholder="Select option"
                allowClear={false}
                value={domainRestriction.type}
                onChange={(value) => {
                  setDomainRestriction({ ...domainRestriction, type: value });
                }}
              >
                {selection_dropdown.map((x, i) => {
                  return (
                    <Option key={i} value={x.value}>
                      {x.label} domains
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Input
                disabled={!domainRestriction.enabled}
                className="select_feld"
                placeholder="www.abc.com,www.xyz.com...."
                value={domainRestriction.values}
                onChange={(value) => {
                  setDomainRestriction({
                    ...domainRestriction,
                    values: value.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <p className="font13">
            By default, the widget will be shown to all visitors. To show or
            hide the widget for visitors from specific domanis/URLs, enable this
            functionality and specify the domanis/URLs.
          </p>
        </Card>
      </Spin>
    </div>
  );
};

export default React.memo(DomainRestriction);
